export default __webpack_public_path__ + "static/N0102-568a6b338220e9b7d7e888e6df4d101e.png";